import { VoiceInputButtonLabels, VoiceInputState } from "./voice-input.types";

export const DEFAULT_LABELS = {
  idle: "Speak",
  recording: "Stop",
  transcribing: "Transcribing",
  processing: "Processing",
  error: "Try again",
  unsupported: "Unavailable",
} satisfies Required<VoiceInputButtonLabels>;

export const STATUS_MESSAGES = {
  idle: "Voice input ready",
  recording: "Recording voice input",
  transcribing: "Transcribing voice input",
  processing: "Processing voice input",
  error: "Voice input needs attention",
} satisfies Record<VoiceInputState, string>;
